export default "/images/vendor/@coreui/icons/svg/flag/cif-th.svg?ccfde3b96b052d7e1351de7a2218b24e";